import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export type DeleteUserPayload = {
  user_id: string;
};
export type DeleteUserResponse = ApiResponse<null>;

export const deleteUser = async (
  payload: DeleteUserPayload
): Promise<DeleteUserResponse> => {
  const { user_id } = payload;
  const url = `user/${user_id}`;

  return await apiClient.delete(url);
};

export function deleteUserMutationOptions() {
  return mutationOptions<DeleteUserResponse, AxiosError, DeleteUserPayload>({
    mutationFn: deleteUser,
  });
}
